import { Component, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UntilDestroy } from '@ngneat/until-destroy';
import { ButtonComponent } from 'mbs-ui-kit';
import { AppPersistentStateService } from 'mbs-ui-shared@services/app-persistent-state.service';
import { MobileApplicationsService } from 'mbs-ui-shared@services/mobile-applications.service';

@UntilDestroy()
@Component({
  selector: 'mbs-install-apps-banner',
  templateUrl: './install-apps-banner.component.html',
  styleUrls: ['./install-apps-banner.component.scss'],
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, ButtonComponent]
})
export class InstallAppsBannerComponent {
  private mobileApplicationsService = inject(MobileApplicationsService);
  private appPersistentState = inject(AppPersistentStateService);

  public installPrompt;

  public close() {
    this.mobileApplicationsService.hideInstallBanner();
    this.appPersistentState.data.showApplicationInstallBanner = false;
  }

  public async openInstallModal() {
    await this.installPrompt?.prompt();
    this.close();
  }
}
